import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy({ open, onClose }) {

    const { t } = useTranslation('common'); 

    const handleCancel = () => {
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Terms of Service</DialogTitle>

        <DialogContent dividers>

            <h1>Terms and Conditions</h1>

            <h2>Introduction</h2>
            <p>These Terms and Conditions (“Agreement”) govern your use of our mobile application (“App”). By accessing or using the App, you agree to comply with these terms. If you do not agree with any part of this Agreement, please do not use the App.</p>

            <h2>User Conduct</h2>
            <p>You must be at least 13 years old to use the App.</p>
            <p>You agree not to:</p>
            <ul>
              <li>Violate any applicable laws or regulations.</li>
              <li>Use the App for any illegal or unauthorized purpose.</li>
              <li>Transmit any harmful or malicious code.</li>
              <li>Attempt to gain unauthorized access to the App or its servers.</li>
              <li>Harass, abuse, or harm other users.</li>
            </ul>

            <h2>Intellectual Property</h2>
            <p>All content in the App, including text, graphics, logos, and images, is protected by copyright and other intellectual property laws.</p>
            <p>You may not reproduce, modify, distribute, or create derivative works based on the App’s content without our explicit permission.</p>

            <h2>Privacy</h2>
            <p>Our Privacy Policy outlines how we collect, use, and protect your personal information. By using the App, you consent to our privacy practices.</p>
            <p>You are responsible for maintaining the confidentiality of your account information.</p>

            <h2>Disclaimers</h2>
            <ul>
              <li>The App is provided “as is” without any warranties or guarantees.</li>
              <li>We are not responsible for any errors, interruptions, or inaccuracies in the App.</li>
              <li>We do not endorse or guarantee the accuracy of any user-generated content.</li>
            </ul>

            <h2>Limitation of Liability</h2>
            <ul>
              <li>We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the App.</li>
              <li>You agree to indemnify and hold us harmless from any claims, losses, or damages related to your use of the App.</li>
            </ul>

            <h2>Changes to This Agreement</h2>
            <p>We reserve the right to modify or update this Agreement at any time. Any changes will be effective immediately upon posting.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions or concerns about these Terms and Conditions, please contact us at info@animora.vet.</p>

            <h1>Privacy Policy</h1>

            <h2>Introduction</h2>
            <p>This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website and use our app. By using our site and app, you agree to the terms outlined in this policy.</p>

            <h2>Information We Collect</h2>
            <ul>
              <li><strong>Personal Information:</strong> Your name, email address, and any other information you voluntarily provide when contacting us or subscribing to our newsletter.</li>
              <li><strong>Log Data:</strong> Our servers automatically record information about your visit, including your IP address, browser type, and pages visited.</li>
              <li><strong>Cookies:</strong> We use cookies to enhance your browsing experience. You can adjust your browser settings to manage cookies or opt-out.</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <ul>
              <li>To improve our website and tailor content to your preferences.</li>
              <li>To respond to inquiries or provide customer support.</li>
              <li>To send newsletters or promotional materials.</li>
            </ul>

            <h2>Data Security</h2>
            <p>We take data security seriously. We implement reasonable measures to protect your information from unauthorized access, disclosure, or alteration.</p>

            <h2>Third-Party Services</h2>
            <p>We may use third-party services (such as Google Analytics) that collect, monitor, and analyze user behavior. These services have their own privacy policies.</p>

            <h2>Your Rights</h2>
            <ul>
              <li>Access and update your personal information.</li>
              <li>Opt-out of marketing communications.</li>
              <li>Request deletion of your data (subject to legal requirements).</li>
            </ul>

            <h2>Changes to This Policy</h2>
            <p>We may update this Privacy Policy periodically. Any changes will be posted on this page.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions or concerns about our Privacy Policy, please contact us at info@animora.vet.</p>


            <h1>Cookie Policy</h1>

            <h2>Introduction</h2>
            <p>This Cookie Policy explains how our website uses cookies and similar tracking technologies. By continuing to browse our site, you consent to the use of cookies as described in this policy.</p>

            <h2>What Are Cookies?</h2>
            <p>Cookies are small text files that websites place and store on users’ computers and mobile devices. These files are generally used to improve the user experience but may contain personal information about the user or their behavior on the website and app.</p>

            <h2>Types of Cookies We Use</h2>
            <ul>
              <li><strong>Necessary Cookies:</strong> Essential for the proper functioning of our website.</li>
              <li><strong>Analytical/Performance Cookies:</strong> Help us analyze how users interact with our site and app.</li>
              <li><strong>Functional Cookies:</strong> Allow the website and app to remember choices you make and provide enhanced features.</li>
              <li><strong>Targeting/Advertising Cookies:</strong> Track your browsing habits and help deliver personalized content and ads.</li>
            </ul>

            <h2>How We Use Cookies</h2>
            <p>We use cookies to understand how you use our site and app, personalize content, and provide relevant advertisements. We do not share cookie data with third parties.</p>

            <h2>Managing Your Cookie Preferences</h2>
            <p>You can manage your cookie preferences by adjusting the settings in your browser. Most browsers allow you to refuse cookies or delete existing ones. However, blocking cookies may impact your experience on our website and app.</p>

            <h2>Third-Party Cookies</h2>
            <p>We use third-party services (such as Google Analytics) that may also set cookies. These cookies are governed by the privacy policies of the respective service providers.</p>

            <h2>Changes to This Policy</h2>
            <p>We may update this Cookie Policy from time to time. Any changes will be posted on this page.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions or concerns about our Cookie Policy, please contact us at info@animora.vet.</p>
                  

        </DialogContent>
          
        <DialogActions>
            <Button onClick={handleCancel}>Close</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}